// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"css/base/colors.css\"","grey-font-color":"#000000","section":"_39qsQQc _1ZWPIqK","header_row":"_1IdIP1w _2wW_gNj","header":"_2GUY_PB undefined","heading":"_1zIMiZX"};